var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-treeview',{staticClass:"tree-view",attrs:{"dense":"","hoverable":"","selectable":"","selected-color":"red darken-1","open-on-click":"","items":_vm.items,"return-object":"","open":_vm.openItems},on:{"input":_vm.onFilterInput,"update:open":_vm.onOpenUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }